import { Dispatch, PropsWithChildren, SetStateAction } from 'react';

import { useAppDispatch } from '../../../../../../store/hooks';
import { DragAndDropProps } from '../../models/drag-and-drop.model';

export const useRemoveFile = (
  props: PropsWithChildren<DragAndDropProps>,
  setFiles: Dispatch<SetStateAction<File[]>>
): ((index: number) => void) => {
  const dispatch = useAppDispatch();
  return (index: number): void => {
    dispatch(props.removeHandler(index));
    setFiles(prevState => {
      return prevState.filter((item, itemIndex) => itemIndex !== index);
    });
  };
};
